// extracted by mini-css-extract-plugin
export default {"checkboxCupom":"update_checkboxCupom__S52YH","inputItemCupom":"update_inputItemCupom__CnHno","configTags":"update_configTags__p3MNS"};